import styled from "styled-components";
import theme from "~/styles/theme";
import { motion } from "framer-motion";

export const StyledMotionDiv = styled(motion.div)`
  background-color: ${theme.palette.neutral.primary.key};

  .div {
    background-color: ${theme.palette.brand.terciary.light};
  }
`;

export const PageHolder = styled.div`
  padding: 0 16px;
  width: 100%;
  text-align: center;
  margin: 32px 0;

  @media (min-width: ${theme.breakpoints.values.md}px) {
    margin: 64px 0;
  }

  p {
    font-family: ${theme.typography.fontFamilyRegular};
    color: ${theme.palette.neutral.primary.key};
  }
`;

export const TitleHolder = styled.div`
  max-width: 328px;
  margin: 0 auto 16px auto;

  @media (min-width: ${theme.breakpoints.values.md}px) {
    max-width: 1007px;
  }

  h1, strong {
    color: ${theme.palette.neutral.primary.key};
  }
`;

export const ButtonHolder = styled.div`
  margin: 32px auto 0 auto;

  button {
    width: 100%;
    max-width: 252px;
    
    &:hover {
      border-color: ${theme.palette.neutral.primary.medium};
      color: ${theme.palette.brand.primary.key};
      background-color: ${theme.palette.neutral.primary.medium};
    }
  }
  @media (min-width: ${theme.breakpoints.values.md}px) {
    max-width: 368px;
  } 
`;
